import React from 'react';
import { convertToHtml } from '@guuru/markdown-common';
import Markdown from './Markdown';

interface MarkdownRenderProps {
  content: string;
  className?: string;
  style?: React.CSSProperties;
  inline?: boolean;
}

const MarkdownRender = ({
  content,
  className,
  style,
  inline = false,
}: MarkdownRenderProps) => {
  const html = convertToHtml(content, inline);

  return inline ? (
    <div
      /* eslint-disable-next-line react/no-danger */
      dangerouslySetInnerHTML={{ __html: html }}
      className={className}
      style={style}
    />
  ) : (
    <Markdown
      style={style}
      className={className}
      /* eslint-disable-next-line react/no-danger */
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default MarkdownRender;
